// material ui
import { alpha, Theme } from '@mui/material';

export const autocompleteCustomization = () => ({
  MuiAutocomplete: {
    styleOverrides: {
      paper: ({ theme }: { theme: Theme }) => ({
        borderRadius: 6,
        color:
          theme.palette.mode === 'dark'
            ? theme.palette.grey[300]
            : 'rgb(55, 65, 81)',
        boxShadow:
          'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      }),
      option: ({ theme }: { theme: Theme }) => ({
        margin: theme.spacing(0.5),
        borderRadius: theme.shape.borderRadius,
        '&[aria-selected="true"]': {
          backgroundColor: theme.palette.action.selected,
          '&.Mui-focused': {
            backgroundColor: theme.palette.action.selected,
          },
        },
        '&:active': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity,
          ),
        },
      }),
      listbox: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
});
